import * as React from 'react';
import { injectIntl } from 'react-intl';
import { Grid, Loader } from 'semantic-ui-react';

import { Card, List, ListResults } from '../..';
import { ALPHAS_UNSUBMITTED_PAGE_PATH } from '../../../shared/constants';
import { formatMessageHelper } from '../../../shared/helpers/internationalization';

import { AlphasMainGeneric } from './types';

const AlphasMain = ({ isFetching, data, permissions, intl }: AlphasMainGeneric) => {
  const items = React.useMemo(() => {
    const unsubmitted = data.get('unsubmitted') as number;
    const active = data.get('active') as number;
    const decommissioned = data.get('decommissioned') as number;
    const total = unsubmitted + active + decommissioned;

    const list = [
      { label: formatMessageHelper(intl, 'dashboardMain.totalAlphasUnsubmitted'), value: unsubmitted },
      { label: formatMessageHelper(intl, 'dashboardMain.totalAlphasActive'), value: active },
      { label: formatMessageHelper(intl, 'dashboardMain.totalAlphasDecommissioned'), value: decommissioned },
      { label: formatMessageHelper(intl, 'dashboardMain.totalAlphas'), value: total },
    ];

    return list;
  }, [data, permissions]);

  return (
    <Grid.Column tablet={8} mobile={16} computer={5}>
      <Card
        addAlphaIcon={true}
        title={formatMessageHelper(intl, 'dashboardMain.dashboardMiddleUpperRow.alpha')}
        headerLink={ALPHAS_UNSUBMITTED_PAGE_PATH}
        headerLinkLabel={formatMessageHelper(intl, 'dashboardMain.dashboardMiddleUpperRow.seeAll')}
      >
        {isFetching ? (
          <div className="'dashboard__loader">
            <Loader active={true} inline="centered" size="massive" />
          </div>
        ) : (
          <List title={formatMessageHelper(intl, 'dashboardMain.dashboardMiddleUpperRow.status')}>
            <ListResults items={items} />
          </List>
        )}
      </Card>
    </Grid.Column>
  );
};

export default injectIntl(AlphasMain);
